import React, { useState } from "react";
import * as styles from "./style.mod.scss";
import CloseIcon from "assets/svgs/close-btn.svg";
import QuestionIcon from "assets/svgs/HelpMeBadge.svg";
import { Modal } from "react-bootstrap";
import RichText from "components/rich-text";
import Image from "components/image";
import Link from "components/link";
import getImagePath from "helpers/get-image-path";

const Switcher = ({ content }) => {
  const [open, setOpen] = useState(false);
  const showModal = () => setOpen(true);
  const hideModal = () => setOpen(false);

  return (
    <div id={content?.addId ? "switcher" : ""}>
      {content?.variantsExtraInformation &&
        <div className={styles.variantsExtraInformationContainer}>
          {content?.variantsExtraInformation?.showQuestionIcon &&
            <a className={styles.question} onClick={showModal}><QuestionIcon /><span><RichText blocks={content?.variantsExtraInformation?.text} /></span></a>}
          <Modal show={open} onHide={hideModal} className={styles.extraInformationsModule}>
            <CloseIcon className={`${styles.modalClose} ${styles.modalCloseDesktop}`} onClick={hideModal} />
            <div className={styles.variantsInformationModal}>
              <p className={styles.title}>{content.variantsExtraInformation?.content?.title}</p>
              {content?.variantsExtraInformation?.content?.text.map((data, i) => {
                return (
                  <div className={styles.singleBox} key={i}>
                    <div className={styles.imageBox}>
                      <Image image={data?.image} alt={data?.image?.alt} />
                    </div>
                    <div className={styles.textBox}>
                      <RichText blocks={data?.description} />
                    </div>

                  </div>
                );
              })}
            </div>
            <div className={styles.modalCloseContainer}>
              <CloseIcon className={`${styles.modalClose} ${styles.modalCloseResponsive}`} onClick={hideModal} />
            </div>
          </Modal>
          {content?.newProductLink &&
            <div className={styles.productGroup}>
              <ul>
                {content?.newProductLink?.map((link, i) => {
                  return (
                    <Link partiallyActive={true} activeClassName={styles.selected} to={`/products${link?.url}`} key={i}>{link?.name}{link?.badge && <img src={getImagePath(link?.badge)} alt={link?.badge?.alt} />}</Link>
                  );
                }
                )}
              </ul>
            </div>
          }
          <div className={styles.description}>
            <RichText blocks={content?.description} />
          </div>
        </div>}
    </div>
  );
};

export default Switcher;